import React, { useState, useRef } from 'react';
import Footer from '../components/Footer';
import LoginFloatingForm from '../components/LoginFloatingForm';
import RegistrationForm from '../components/RegistrationForm';
import Header from '../components/Header';

function Home() {
  // Ref para el bloque 6
  const block6Ref = useRef(null);

  // Estado para controlar la visibilidad del formulario
  const [isFormVisible, setIsFormVisible] = useState(true);

  // Función para desplazar la vista al bloque 6
  const scrollToCrearCuenta = () => {
    if (block6Ref.current) {
      block6Ref.current.scrollIntoView({ behavior: 'smooth' });
      setIsFormVisible(false);
    }
  };

  return (
    <>
      <Header />

      <LoginFloatingForm
        isFormVisible={isFormVisible}
        setIsFormVisible={setIsFormVisible}
        scrollToCrearCuenta={scrollToCrearCuenta}
      />

      <div className='auteco_bloque1'>
        <div className='titulos'>
          <div className='titulo'>Curso virtual para motociclistas</div>

          <div className='subtitulo'>¡Conviértete en un conductor responsable de motocicletas desde cualquier lugar!</div>

          <div className='botones'>
            <div className='auteco_button secondary' onClick={scrollToCrearCuenta}>
              Crear una cuenta
            </div>
            <button className='auteco_button primary' onClick={() => setIsFormVisible(true)}>
              Iniciar sesión
            </button>
          </div>
        </div>
      </div>

      <div className='auteco_bloque2'>
        <div className='logos'>
          <div className='logo'></div>
        </div>

        <div className='contenedor-separador-vertical'>
          <div className='auteco_separador-vertical'></div>
        </div>

        <div className='contenedor-textos'>
          <div className='titulo'>Curso virtual <br />para motociclistas</div>
          <div className='contenedor-separador-horizontal'>
            <div className='auteco_separador-horizontal'></div>
          </div>
          <div className='texto'>¿Te apasionan las motos o estás empezando a interesarte en ellas? <br /><br />
            Nuestro <strong>Curso Virtual para Motociclistas</strong> te abre las puertas al fascinante mundo de las dos ruedas. Aprende desde los conceptos básicos hasta consejos prácticos, ¡totalmente gratis y al alcance de todos!
          </div>
        </div>

      </div>

      <div className='auteco_bloque3'>
        <div className='titulos'>
          <div className='titulo'>Preguntas frecuentes</div>
          <div className='container-separador'>
            <div className='auteco_separador-horizontal' />
          </div>
        </div>

        <div className='preguntas'>
          <div className='pregunta'>
            <div className='titulo'>¿Para quién es?</div>
            <div className='textos'>
              <div className='icono'>
                <div className='icono-team'></div>
              </div>
              <div className='texto'>Para cualquier persona interesada en aprender sobre una conducción segura de motos.</div>
            </div>
          </div>

          <div className='pregunta'>
            <div className='titulo'>¿Tiene costo?</div>
            <div className='textos'>
              <div className='icono'>
                <div className='icono-pay'></div>
              </div>
              <div className='texto'>!No, es totalmente gratuito!</div>
            </div>
          </div>

          <div className='pregunta'>
            <div className='titulo'>¿Cuánto tarda?</div>
            <div className='textos'>
              <div className='icono'>
                <div className='icono-time'></div>
              </div>
              <div className='texto'>Solo 25 minutos.</div>
            </div>
          </div>

          <div className='pregunta'>
            <div className='titulo'>¿Por qué es importante?</div>
            <div className='textos'>
              <div className='icono'>
                <div className='icono-safety'></div>
              </div>
              <div className='texto'>Porque aprendes de técnicas de manejo, conoces sobre motocicletas y su buen uso.</div>
            </div>
          </div>

          <div className='pregunta'>
            <div className='titulo'>¿Cuántas oportunidades tengo?</div>
            <div className='textos'>
              <div className='icono'>
                <div className='icono-bulb'></div>
              </div>
              <div className='texto'>Tantas como quieras, no hay límites.</div>
            </div>
          </div>

          <div className='pregunta'>
            <div className='titulo'>¿Qué van a hacer con mis datos?</div>
            <div className='textos'>
              <div className='icono'>
                <div className='icono-search'></div>
              </div>
              <div className='texto'>Los usaremos para generar tu certificado.</div>
            </div>
          </div>

        </div>
      </div>

      <div className='auteco_bloque4'>
        <div className='titulo'>¿Cómo participar?</div>
        <div className='container-separador'>
          <div className='auteco_separador-horizontal' />
        </div>
        <div className='subtitulo'>
          ¡Es muy fácil! Sigue estos simples pasos para comenzar tu aprendizaje:
        </div>

        <div className='linea'></div>
        <div className='tarjetas'>
          <div className='tarjeta'>
            <div className='circulo'></div>
            <div className='icono icono-form'></div>
            <div className='titulo'>Paso 1: Regístrate</div>
            <div className='texto'>Crea tu cuenta en nuestra plataforma con solo unos clics. Es rápido, seguro y gratuito.</div>
          </div>
          <div className='tarjeta'>
            <div className='circulo'></div>
            <div className='icono icono-learning'></div>
            <div className='titulo'>Paso 2: Accede al curso</div>
            <div className='texto'>Explora el contenido disponible y empieza tu recorrido en el fascinante mundo de las motocicletas dando clic en el Curso Virtual para Motociclistas.</div>
          </div>
          <div className='tarjeta'>
            <div className='circulo'></div>
            <div className='icono icono-graduated'></div>
            <div className='titulo'>Paso 3: Obtén tu certificado</div>
            <div className='texto'>Completa el curso y recibe un certificado que respalda tu aprendizaje.</div>
          </div>
        </div>
      </div>

      <div className='auteco_bloque5'>
        <div className='titulos'>
          <div className='titulo'>¿Ya estás registrado?</div>
          <div className='container-separador'>
            <div className='auteco_separador-horizontal' />
          </div>
          <div className='subtitulo'>
            Inicia sesión y continúa tu aprendizaje.
          </div>
        </div>
        <div className='boton'>
          <button className='auteco_button primary' onClick={() => setIsFormVisible(true)}>Inicia sesión</button>
        </div>
      </div>

      <div ref={block6Ref} className='auteco_bloque6'>
        <div className='titulo'>Regístrate</div>
        <div className='container-separador'>
          <div className='auteco_separador-horizontal' />
        </div>
        <div className='subtitulo'>
          ¡Regístrate ahora y accede, Es fácil, rápido y te permitirá empezar de inmediato. Si ya tienes una cuenta
          <span onClick={() => setIsFormVisible(true)}>inicia sesión aquí</span>
        </div>
        <br />
        <RegistrationForm />
      </div>

      <Footer />
    </>
  );
}

export default Home;
